<template>
  <div class="tarjeta-aplicador shadow-sm">

    <Aurora :color-stops="['#35656f', '#B49754', '#283046']" :amplitude="1.5" :blend="0.3" :speed="1.0" :intensity="1.0"
      class="w-full h-full" />

    <section class="contenido-aplicador">
      <!-- <h3 class="text-center ">{{ titulo }}</h3> -->

      <figure>
        <b-img :src="CodigoPromocional" class="imagen-promocional"></b-img>
        <!-- <font-awesome-icon icon="fas fa-ticket" size="3x"/> -->
      </figure>

      <strong class="text-center  text-nowrap">
        Ingresa aquí tu Código de Activación"
      </strong>

      <b-form @submit.prevent="canjear" id="form-canjeador">

        <b-form-group class="text-center w-100">
          <b-form-input placeholder="MB_12345" size="lg" v-model="codigo" v-bind="codigo_attrs"
            :state="!errors.codigo" />
        </b-form-group>

        <b-button variant="secondary" type="submit" size="lg" class="btn-canjeador" style="margin-top:5px;">
          <font-awesome-icon icon="fa-solid fa-ticket" style="margin-right:5px;" />
          <strong>Canjear <span class="d-none d-md-inline">Cupón</span></strong>
        </b-button>

      </b-form>

      <small class="text-center lh-1  fs-6  text-white  legend">
        Canjea aquí los códigos de productos o de regalos.
        Los cupones de descuento se canjean en la tienda.
      </small>

    </section>

  </div>
</template>

<script setup>

import { useForm } from 'vee-validate';
import {required} from '@validations';
import useCuponStore from '@/store/cupon';
import useUtils  from '@composables/useUtils';
import useUsuarioStore from '@/store/usuario';
import CodigoPromocional from '@images/icons/codigo-promocional.png';
import Aurora from "components/Aurora.vue";
import {useRouter} from 'vue-router';
const router = useRouter();
const cupon_store = useCuponStore();

const {
  loading
} = useUtils();
const props = defineProps({
  titulo: {
    type: String,
    default: 'Canjear Cupón'
  }
});
const usuario_store = useUsuarioStore();
const {usuario_id} = storeToRefs(usuario_store);
const {handleSubmit,resetForm,errors,setErrors,defineField} = useForm({
  initialValues:{
    codigo:''
  },
  validationSchema: {
    codigo: required
  }
});
const [codigo,codigo_attrs]  = defineField('codigo');


const canjear = handleSubmit((values) => {
  cupon_store.verificarCodigo(values,['permiso','lote','descuento','biografia'])
  .then(({valido,beneficios}) => {
    if(valido){
    const beneficiosStr = beneficios.map(b => b.nombre).join(', ');
    preguntar({
     title: `El cupón es válido`,
     html: `El cupón tiene los siguientes beneficios:<br> <strong>${beneficiosStr}</strong>. <br> ¿Desea canjear el cupón?`,
     },() => {
      cupon_store.canjearCodigo(values,usuario_id.value)
      .then(({result,is_biografia,bio_id}) => {
        if(result){
          usuario_store.refetchUsuario(usuario_id.value);

          if(is_biografia){
            preguntar({
              title:`Cupón Canjeado`,
              html:`El Cupón aplicado tiene una Configuración de Biografía iniciada. <br> ̉¿Desea configurar su biografía ahora?`
            },() => {
              router.push({
                name:'biografia.edit',
                params:{id:bio_id}
              })
            })
          }else{
            swal({
              title: 'Cupón Canjeado',
              html: `El cupón ha sido canjeado exitosamente. Beneficios aplicados: <br> <strong>${beneficiosStr}</strong>. <br> `,
              icon: 'success'
            });
          }
          
        

        }else{
          toast.error("El cupón no es válido o ya ha sido canjeado.");
        }
        resetForm();
      })
     });
    }else{
      toast.error("El cupón no es válido o ya ha sido canjeado.");
    }
  });
})
</script>

<style lang="scss" scoped>
@use "@variables/variables" as *;


.tarjeta-aplicador{

  --radius: 16px; /* radio de esquinas del mock */
  min-width: 280px;
  width:100%;
  position:relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex:1 1 auto;
  padding:1rem;
  margin-bottom:0px;
  font-family: 'JosefinSans-Regular';
  // Fondo degradado moderno (inspirado en el ticket ejemplo)
  // linear-gradient(90deg, $primary 20%, $dark 90%);
  background: $dark;
  color: $blanco;
  box-shadow: 0 12px 24px rgba($black,0.08);
  border-radius: var(--radius);
  // border: 5px inset black !important;
  overflow-x: hidden;
  position: relative;


  &::before,
  &::after {
      content: '';
      position: absolute;
      width: 60px;
      height: 60px;
      /* Se ha restaurado el color de fondo para las muescas */
      background: #f0f2f5;

      border-radius: 50%;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }

    &::before {
      left: -30px;
    }

    &::after {
      right: -30px;
    }
  
}






.contenido-aplicador{
  position:relative;
  display:flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width:calc(100% - 60px);
  padding: 5px;
  margin:0 auto;
  z-index:10;
  

  .imagen-promocional{
    width:80px;
    height:80px;
    margin-bottom:10px;
  }

  strong {
    font-family: 'JosefinSans-SemiBold';
    margin-bottom:10px;
    font-size:16pt;
  }

  h3{
    margin-bottom:10px;
    font-weight: 600 !important;
    font-family:'JosefinSans-SemiBold';
  }

  #form-canjeador{
    display: flex;
    flex-direction: column;
    align-items:center;
    width:calc(100%);

    @media (min-width:998px){
      width: calc(65%);
    }
  }
  input{
    font-size:14pt;
  }

  .btn-canjeador{
    background:$secondary !important;
    border:none !important;
    box-shadow: 0 4px 6px rgba($black,0.1);
    transition: background 0.3s ease;
    width:100%;
    color: white !important;
    font-family: 'JosefinSans-Regular';
    &:hover{
      background:darken($secondary,10%) !important;
    }
  }

  .legend{
    // background:$color-fondo-menu-2;
    width:100%;
    align-self:center;
    margin-top:30px;
    padding: 5px;
    border-radius: 5px;
    font-family: 'JosefinSans-Regular';

    @media (min-width:998px) {
        width: calc(65%);
    }

  }
}

</style>